export function validOrZero(s) {
  return s || s === 0;
}



// WEBPACK FOOTER //
// ./src/libraries/form/utilities/utils.js